import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-6 bg-carbon-light" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-carbon border border-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-[0_0_40px_rgba(242,183,5,0.1)]" data-id="element-146">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-147" />

          <ShieldCheckIcon className="w-20 h-20 text-gold mx-auto mb-6" data-id="element-148" />

          <h2 className="font-heading text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-149">
            Nuestra Garantía de Resultados
          </h2>

          <p className="text-neutral-300 font-body text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-8" data-id="element-150">
            Confiamos tanto en el Sistema A.C.E.™ que te ofrecemos una garantía
            audaz: Si no aumentamos tu facturación mensual con nuevos contratos
            recurrentes en los primeros 90 días,{' '}
            <strong className="text-gold font-semibold" data-id="element-151">
              trabajamos gratis hasta lograrlo.
            </strong>
          </p>

          <p className="text-neutral-400 font-body text-sm" data-id="element-152">
            * Cero riesgo para ti. Todo el riesgo lo asumimos nosotros.
          </p>
        </motion.div>
      </div>
    </section>;
}